import { AnimatePresence } from "framer-motion";
import { useOnboardingTour } from "../../lib/useOnboardingTour";
import { TourStep } from "./TourStep";

export function MobileOnboardingTour() {
  const tour = useOnboardingTour({ platform: "mobile" });

  if (!tour.isActive) return null;

  return (
    <AnimatePresence mode="wait">
      <TourStep
        key={tour.step}
        step={tour.currentStep}
        stepIndex={tour.step}
        totalSteps={tour.totalSteps}
        onNext={tour.next}
        onBack={tour.back}
        onFinish={tour.finish}
        isFirst={tour.isFirstStep}
        isLast={tour.isLastStep}
      />
    </AnimatePresence>
  );
}
